import { TopicDistributionItem } from './dashboardApi';

export interface TopicsDataset {
  labels: string[];
  values: number[];
  colors: string[];
  sdgNumbers: Array<number | null>;
}

const OTHERS_LABEL = 'Others';
const TOPIC_COLORS = ['#0f172a', '#1d3a8a', '#1d4ed8', '#2563eb', '#3b82f6'];
const OTHERS_COLOR = '#94a3b8';

export const buildTopicsDataset = (
  topics: TopicDistributionItem[],
  othersCount: number = 0
): TopicsDataset => {
  if (!topics?.length && !othersCount) {
    return { labels: [], values: [], colors: [], sdgNumbers: [] };
  }

  const labels = topics.map((topic) => topic.name || `SDG ${topic.sdg_number}`);
  const values = topics.map((topic) => topic.message_count ?? 0);
  const colors = topics.map(
    (_, idx) => TOPIC_COLORS[idx] ?? TOPIC_COLORS[TOPIC_COLORS.length - 1]
  );
  const sdgNumbers: Array<number | null> = topics.map(
    (topic) => (typeof topic.sdg_number === 'number' ? topic.sdg_number : null)
  );

  if (othersCount > 0) {
    labels.push(OTHERS_LABEL);
    values.push(othersCount);
    colors.push(OTHERS_COLOR);
    sdgNumbers.push(null);
  }

  return { labels, values, colors, sdgNumbers };
};
